export default ({
  state: {
    BanksForm: [
      { field: 'radioButton', name: 'Tipo Credito', nameid: 'tipo_calculo', items: ['CREDITO BANCARIO', 'CREDITO FOVISSSTE'], row: true, rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Nombre', nameid: 'nombre', rules: true, cols: 12 },
      { field: 'number', type: 'text', name: 'Nombre Tasa', nameid: 'tasa_nombre', rules: true, cols: 6 },
      { field: 'number', type: 'number', name: 'Tasa', nameid: 'tasa', rules: true, cols: 6 },
      { field: 'number', type: 'number', name: 'Dias del Mes', nameid: 'dias_mes', rules: true, cols: 6 },
      { field: 'number', type: 'number', name: 'Dias del Año', nameid: 'dias_anio', rules: true, cols: 6 },
      { field: 'number', type: 'number', name: 'Seguro de Daños', nameid: 'seguroddanios', rules: false, cols: 6 },
      { field: 'number', type: 'number', name: 'Comision', nameid: 'comision', rules: false, cols: 6 }
    ],
    DeadlinesForm: [
      // { field: 'text', type: 'text', name: 'Plazo', nameid: 'plazo', rules: true, cols: 12 },
      { field: 'select', name: 'Plazo', nameid: 'plazo', rules: true, items: ['10 AÑOS', '15 AÑOS', '20 AÑOS'], cols: 12 },
      { field: 'number', type: 'number', name: 'Capital', nameid: 'capital', rules: true, cols: 12 },
      { field: 'number', type: 'number', name: 'Seguro de Vida', nameid: 'seguroVida', rules: true, cols: 12 }
    ],
    UserForm: [
      { field: 'text', type: 'text', name: 'Nombre Completo', nameid: 'nombre', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Usuario', nameid: 'usuario', rules: true, cols: 6 },
      { field: 'text', type: 'email', name: 'Correo Electronico', nameid: 'correo', rules: true, cols: 6 },
      { field: 'text', type: 'password', name: 'Contraseña', nameid: 'password', rules: true, cols: 6 },
      { field: 'text', type: 'password', name: 'Confirmar Contraseña', nameid: 'confirmPassword', rules: true, cols: 6 }
    ],
    UserUpdateForm: [
      { field: 'text', type: 'text', name: 'Nombre Completo', nameid: 'nombre', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Usuario', nameid: 'usuario', rules: true, cols: 6 },
      { field: 'text', type: 'email', name: 'Correo Electronico', nameid: 'correo', rules: true, cols: 6 }
    ],

    AsignarRollUserForm: [
      { field: 'viewText', name: 'Nombre Completo', nameid: 'nombre', cols: 12 },
      { field: 'viewText', name: 'Usuario', nameid: 'usuario', cols: 6 },
      { field: 'viewText', name: 'Correo', nameid: 'correo', cols: 6 },
      { field: 'viewText', name: 'Rol Asignado', nameid: 'roles', cols: 12 },
      { field: 'selectDataServer', name: 'Roles', nameid: 'rol_id', url: '/auth/roles', rules: true, cols: 12, post: true, data: {} }
    ],
    UserProfileForm: [
      { field: 'text', type: 'text', name: 'Nombre Completo', nameid: 'nombre', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Usuario', nameid: 'usuario', rules: true, cols: 6 },
      { field: 'text', type: 'email', name: 'Correo', nameid: 'email', rules: true, cols: 6 }
    ],
    RolesForm: [
      { field: 'text', type: 'text', name: 'Nombre Rol', nameid: 'nombre', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'clave', nameid: 'slug', rules: true, cols: 12 }
    ],
    CustomerForm: [
      { field: 'text', type: 'text', name: 'Nombres', nameid: 'nombres', rules: true, cols: 6 },
      { field: 'text', type: 'text', name: 'Apellidos', nameid: 'apellidos', rules: true, cols: 6 },
      { field: 'text', type: 'date', name: 'Fecha Nacimiento', nameid: 'fecha_nacimiento', rules: true, cols: 8 },
      { field: 'text', type: 'text', name: 'Correo', nameid: 'correo', rules: true, cols: 6 },
      { field: 'text', type: 'text', name: 'Telefono', nameid: 'telefono', rules: true, cols: 6 },

      { field: 'text', type: 'text', name: 'NSS', nameid: 'nss', rules: true, cols: 4 },
      { field: 'text', type: 'text', name: 'RFC', nameid: 'rfc', rules: true, cols: 4 },
      { field: 'text', type: 'text', name: 'CURP', nameid: 'curp', rules: true, cols: 4 },
      { field: 'radioButton', name: 'Estado Civil', items: ['soltero', 'casado', 'union_libre'], rules: true, nameid: 'estado_civil', row: true, cols: 12, action: 'ShowFieldDinamic', isHidden: ['emparejamiento'] },
      { field: 'text', type: 'text', name: 'Tipo Emparejamiento', nameid: 'emparejamiento', rules: true, cols: 6, hidden: true }
    ],
    CorreosdForm: [
      { field: 'text', type: 'text', name: 'Correo', nameid: 'contacto', rules: true, cols: 12 }
    ]
  },
  getters: {
    get_CustomerForm (store) {
      return store.CustomerForm
    },
    get_CorreosdForm (store) {
      return store.CorreosdForm
    },
    get_BanksForm (store) {
      return store.BanksForm
    },
    get_DeadlinesForm (store) {
      return store.DeadlinesForm
    },
    get_UserForm (store) {
      return store.UserForm
    },
    get_UserUpdateForm (store) {
      return store.UserUpdateForm
    },

    get_AsignarRollUserForm (store) {
      return store.AsignarRollUserForm
    },
    get_UserProfileForm (store) {
      return store.UserProfileForm
    },
    get_RolesForm (store) {
      return store.RolesForm
    }
  },
  mutations: {},
  actions: {}
})
